// src/pages/Home.js
import React from "react";
import { Link } from "react-router-dom";
import ReviewMarquee from "../components/ReviewMarquee";
import HomeTeamStrip from "../components/HomeTeamStrip";

export default function Home() {
  return (
    <div>
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-gradient" />

        <div className="container hero-inner">
          <div className="hero-content">
            <p className="hero-kicker">
              FLORIDA RESIDENTIAL • LUXURY • INVESTMENT
            </p>

            <h1 className="hero-title">
              Buy & sell Florida real estate
              <span>without feeling lost in the process.</span>
            </h1>

            <p className="hero-subtitle">
              Platinum Palm Properties is a modern Florida brokerage built for
              buyers, sellers, and families who want clean marketing,
              clear numbers, and fast results.
            </p>

            <div className="hero-actions">
              <Link to="/listings" className="btn btn-primary">
                Browse Active Listings
              </Link>
              <Link to="/sell" className="btn btn-ghost">
                Get a Free Home Value
              </Link>
            </div>

            <div className="hero-bullets">
              <span>• Single family & new construction</span>
              <span>• Waterfront & pool homes</span>
              <span>• Homestead & Ranches</span>
            </div>
          </div>
        </div>
      </section>

{/* Agents Preview Section */}
  <HomeTeamStrip />

      
      <ReviewMarquee />
          </div>
  );
}
